import { Request } from '../utils';

const prefix = 'common';

// GET System User Roles
export const getSystemUserRoles = () => {
  return Request.get(`${prefix}/admin_role`, { onlyError: true });
};

// GET Pharmacy User Roles
export const getPharmacyUserRoles = () => {
  return Request.get(`${prefix}/pharmacy_role`, { onlyError: true });
};

// GET Pharmacy - Support Subjects
export const getPharmacySupportSubjects = () => {
  return Request.get(`${prefix}/subject`, { onlyError: true });
};
